<div class="page-container gap-3">
  <app-page-header
    title="Data Library"
    description="Store variables and collections you can reuse across your forms.">
    <div class="inline-block" [cdkMenuTriggerFor]="newTypeMenu">
      <lib-signal-button
        iconSrc="assets/icons/plus.svg"
        [fullWidth]="false">
        New
      </lib-signal-button>
    </div>
  </app-page-header>

  <ng-template #newTypeMenu>
    <div
      cdkMenu
      class="mt-2 min-w-44 rounded-xl border border-neutral-200 bg-white py-1.5 shadow-sm">
      @for (item of newTypeItems; track item.id) {
        <button
          type="button"
          cdkMenuItem
          class="flex w-full cursor-pointer items-center gap-3 border-0 bg-transparent px-3.5 py-2.5 text-left text-sm text-neutral-800 transition hover:bg-neutral-50"
          (click)="onNewTypeSelected(item.id)">
          <app-svg-icon [class]="item.iconClass" [src]="item.iconSrc" [size]="18" />
          <span>{{ item.label }}</span>
        </button>
      }
    </div>
  </ng-template>

  <section class="page-fill rounded-2xl border border-neutral-200 bg-white">
    <app-signal-data-table
      class="page-fill-host"
      [columnDefs]="columnDefs"
      [state]="tableState"
      [pageSize]="100"
      (tableStateChanged)="onTableStateChanged($event)"
      (onActionPerformed)="onTableAction($event)"
      (onRowClicked)="onRowClicked($event)" />
  </section>
</div>
